// TODO: refactor jQuery --> ES
export default class SearchAutocompletion {
	constructor(app) {
		this.app = app;
		const self = this;

		self.$inputElem = $(".js-input-quicksearch");
		self.$spinnerElem = $(".js-search-spinner");
		self.$suggestionBox = null;
		self.ajaxURL = "/search/query";
		self.selectionIndex = 0;

		self.init();
	}

	init() {
		let self = this;

		if (self.$inputElem.length === 0) {
			if (self.app.info.isDebug) {
				console.debug("Cannot init searchAutocompletion on given element, input-element not found.");
			}
			return false;
		}

		self.$suggestionBox = self.attachSuggestionbox();

		self.$inputElem
			.attr('autocomplete', 'off')
			.on('keydown', function (e) {
				let key = e.key;

				switch (key) {
					case 'PageUp':
					case 'ArrowUp':
						self.selectionIndex--;
						if (self.selectionIndex <= 0) {
							self.selectionIndex = self.$suggestionBox.find('.suggestion-box-item').length;
							self.$suggestionBox.scrollTop(self.$suggestionBox.prop('scrollHeight'));
						}

						self.$suggestionBox.find('.suggestion-box-item').removeClass('is-active');
						var $activeItem = self.$suggestionBox.find('.suggestion-box-item').eq(self.selectionIndex - 1).addClass('is-active');
						var posActiveItem = $activeItem.position().top - $activeItem.parent().position().top;

						if (posActiveItem < self.$suggestionBox.scrollTop()) {
							self.$suggestionBox.scrollTop(posActiveItem);
						}

						break;

					case 'PageDown':
					case 'ArrowDown':
						self.selectionIndex++;
						if (self.selectionIndex > self.$suggestionBox.find('.suggestion-box-item').length) {
							self.selectionIndex = 1;
							self.$suggestionBox.scrollTop(0);
						}

						self.$suggestionBox.find('.suggestion-box-item').removeClass('is-active');
						var $activeItem = self.$suggestionBox.find('.suggestion-box-item').eq(self.selectionIndex - 1).addClass('is-active');
						var posActiveItem = $activeItem.position().top - $activeItem.parent().position().top;

						if (posActiveItem + $activeItem.height() > self.$suggestionBox.scrollTop() + self.$suggestionBox.outerHeight()) {
							self.$suggestionBox.scrollTop(posActiveItem + $activeItem.outerHeight() - self.$suggestionBox.outerHeight());
						}

						break;

					case 'Enter':
						if (self.$suggestionBox.find('.suggestion-box-item.is-active').length) {
							self.onSelect(self.$suggestionBox.find('.suggestion-box-item.is-active'));
							e.preventDefault(); // prevent send form
						}
						break;

					case 'Escape':
						self.$suggestionBox.hide();
						break;
				}
			})
			.on('keyup', function (e) {
				let key = e.key;

				switch (key) {
					case 'PageUp':
					case 'ArrowUp':
					case 'PageDown':
					case 'ArrowDown':
					case 'Enter':
					case 'Escape':
						break;

					default:
						if (self.$inputElem.val().length >= 2)
							self.updateSuggestions();
						else
							self.$suggestionBox.hide();

						self.selectionIndex = 0; // reset selectionIndex for new suggestions
						break;
				}
			})
			.on('focusout', function (e) {
				self.$suggestionBox.hide();
			})
			.focus();
	}

	attachSuggestionbox() {
		let self = this;

		return $(self._getSuggestionBoxPrototype())
			.hide()
			.appendTo('body')
			.on('show', (e) => {
				let offset = self.$inputElem.offset();
				let width = self.$inputElem.innerWidth(); // use here innerWidth because of the border
				let height = self.$inputElem.outerHeight();

				$(e.currentTarget)
					.width(width)
					.css('left', offset.left)
					.css('top', offset.top + height)
					.show()
			});
	}

	updateSuggestions() {
		let self = this;

		$.ajax({
			url: self.ajaxURL,
			data: {
				term: self.$inputElem.val()
			},
			dataType: 'json',
			success: function (response) {
				let items = '';

				response.forEach(function (value) {
					items += self._getSuggestionItemPrototype()
						.replace('{{value}}', value.label)
						.replace('{{url}}', value.url);
				});

				self.$suggestionBox.html(
					self._getSuggestionBoxContentPrototype()
						.replace('{{items}}', items)
				).trigger('show');

				self.$suggestionBox.find('.suggestion-box-item').on('mousedown', function (e) {
					// prevents to fire blur before click
					e.preventDefault();
				}).on('click', function (e) {
					self.onSelect($(this));
				})
			}
		});

	}

	onSelect($element) {
		if ($element.length) {
			window.location.href = $element.data('url');
		}
	}

	_getSuggestionBoxPrototype() {
		return '<div class="suggestion-box"><div>';
	}

	_getSuggestionBoxContentPrototype() {
		return '<ul class="suggestion-box-list">{{items}}</ul>';
	}

	_getSuggestionItemPrototype() {
		return '<li class="suggestion-box-item" data-url="{{url}}">{{value}}</li>';
	}
}
